"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useMessage = () => {
  const [message, setMessageText] = (0, _react.useState)('');
  const [type, setType] = (0, _react.useState)('');
  const setMessage = newMessage => {
    setMessageText(newMessage.message);
    setType(newMessage.type);
  };
  const resetMessage = () => {
    setMessageText('');
    setType('');
  };
  return [message, type, setMessage, resetMessage];
};
var _default = exports.default = useMessage;